<template>
  <LoadingState
    v-if="!method"
    :loading="true"
  />
  <v-layout
    v-else
    row
    wrap
    color="transparent"
  >
    <v-flex xs12>
      <translations-tabs
        class="pb-4"
      >
        <template #default="{language}">
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <translatable
                :language="language"
                v-model="method"
                field-name="name"
              >
                <template
                  #default="{ fieldValue, fieldMutator }"
                >
                  <v-text-field
                    v-model="fieldValue"
                    :error-messages="method.displayErrors('name')"
                    :label="$t('Name')"
                    outline
                    @change="fieldMutator(fieldValue)"
                  />
                </template>
              </translatable>
            </v-flex>
            <v-flex xs12>
              <translatable
                :language="language"
                v-model="method"
                field-name="description"
              >
                <template
                  #default="{ fieldValue, fieldMutator }"
                >
                  <v-text-field
                    v-model="fieldValue"
                    :error-messages="method.displayErrors('description')"
                    :label="$t('Description')"
                    outline
                    @change="fieldMutator(fieldValue)"
                  />
                </template>
              </translatable>
            </v-flex>
          </v-layout>
        </template>
      </translations-tabs>
    </v-flex>

    <v-flex xs12>
      <v-layout align-start>
        <v-flex>
          <v-switch
            v-model="method.testMode"
            :label="$t('Test mode')"
          />
        </v-flex>
        <v-flex>
          <v-switch
            v-model="method.auto_pay"
            :label="$t('Automatically Pay')"
            :hint="$t('Some text')"
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-text-field
        v-model.number="method.order"
        :error-messages="method.displayErrors('order')"
        :label="$t('Order')"
        type="number"
        outline
      />
    </v-flex>

    <v-flex xs12>
      <application-select v-model="method.application"/>
    </v-flex>

    <v-flex xs12>
      <image-upload v-model="method.image"/>
    </v-flex>
  </v-layout>
</template>

<script>
import ApplicationSelect from '@/components/form/ApplicationSelect'
import ImageUpload from '@/components/ImageUpload'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import Translatable from '@/components/widgets/Translatable'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'PaymentOffline',
  components: { Translatable, TranslationsTabs, ImageUpload, ApplicationSelect, LoadingState },
  props: {
    method: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      schema: {
        'code': '',
        'name': '',
        'application': null,
        'enabled': true,
        'testMode': true,
        'description': '',
        'image': '',
        'order': null,
        'auto_pay': false
      }
    }
  },

  created () {
    this.$emit('setPaymentData', {
      schema: this.schema
    })
  }
}
</script>
